import {  SET_RUTA } from "../ActionTypes";

const ruta = (state, { payload, type }) => {
  switch (type) {
    case SET_RUTA:
      return {
        ...state,
        ruta:{
          ...state.ruta,
          error: false,
          data: payload,
        },
      };


    default:
      return state;
  }
};

export default ruta;
